import React from 'react';
import { ensureBoolean, isNotEmpty, shuffleArray } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';

import LikeDislikeCanvas from '../games/LikeDislikeCanvas.js';
import SimpleCanvasContainer from './SimpleCanvasContainer.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import LikeDislikeFinal from './LikeDislikeFinal.js';

const LikeDislikeClient = ({ stage, ...props }) => {
	const is_builder = props?.is_builder ?? false;
	const is_test = props?.is_test ?? false;

	const final_stage = JSON.parse(JSON.stringify(stage));
	final_stage.Stage.instructions_disabled = true;	// no instructions in this game_type
	final_stage.Stage.override_promo_styles = true;	// no final_page in this game_type
	if((!is_builder || is_test) && ensureBoolean(stage.Stage?.likedislike_random_display ?? 'false')) {
		shuffleArray(final_stage?.Stage?.likedislike_players);
	}

	const players = (isNotEmpty(final_stage.Stage, 'likedislike_players')) ? final_stage.Stage.likedislike_players : [];

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage.Stage, 'full_game_final_bg_image')) {
			images.push({
				id:'final_bg_img',
				name:stage.Stage.game_final_bg_image,
				url:stage.Stage.full_game_final_bg_image,
				image:stage.Stage.full_game_final_bg_image,
				fit:'cover',
			});
		}

		if(isNotEmpty(stage.Stage, 'bg_image')) {
			images.push({
				id:'bg_image',
				name:stage.Stage.bg_image,
				url:stage.Stage.full_bg_image,
				fit:'cover',
			});
		}

		if(isNotEmpty(stage.Stage, 'likedislike_like_image')) {
			images.push({
				id:`like_icon`,
				name:stage.Stage.likedislike_like_image,
				url:stage.Stage.full_likedislike_like_image,
				image:stage.Stage.full_likedislike_like_image,
				fit:'contain',
			});
		}

		if(isNotEmpty(stage.Stage, 'likedislike_dislike_image')) {
			images.push({
				id:`dislike_icon`,
				name:stage.Stage.likedislike_dislike_image,
				url:stage.Stage.full_likedislike_dislike_image,
				image:stage.Stage.full_likedislike_dislike_image,
				fit:'contain',
			});
		}

		players.map((player) => {
			if(isNotEmpty(player, 'image')) {
				images.push({
					id:`player_${player.id}`,
					name:player.image,
					url:player.full_image,
					image:player.full_image,
					fit:'contain',
				});
			}
		});

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.Stage.likedislike_players,
			stage.Stage.likedislike_like_image,
			stage.Stage.likedislike_dislike_image,
			stage.Stage.bg_image,
			stage.Stage.final_bg_image,
		],
	});

	const missing_anything = (players.length < 2) ? true : false;

	let preview_index = false;
	if(is_builder && !is_test) {
		preview_index = props?.preview_index ?? 0;
		//if(preview_index == 0) preview_index = 1;
	}

	let full_key = `likedislike_${players.length}`;

	const default_props = {
		is_builder,
		is_test,
		indexed_images:state.images,
		loaded_status:state.state,
		locale:props.locale,
	};

	const fake_total_plays = Math.ceil(10000 * Math.random());
	const fake_user_answer = [];
	const fake_stats = [];
	players.map((pl) => {
		const percent_likes = Math.floor(fake_total_plays * Math.random());
		fake_stats.push({ id:pl.id, like:percent_likes, dislike:fake_total_plays - percent_likes });

		fake_user_answer.push({ id:pl.id, type:(Math.random() - 0.5 > 0) ? 'like' : 'dislike', time:Math.round(300 * Math.random()) / 100 });
	});

	const stats = props?.stats ?? ((!is_builder || is_test) ? [] : fake_stats);
	
	if(is_builder && !is_test) {
		default_props.fake_user_answer = { likedislike:fake_user_answer };
	}

	return (
		<SimpleCanvasContainer
			{...props}
			key={full_key}
			stage={final_stage}
			final_page={<LikeDislikeFinal
				{...default_props}
				stats={stats}
			/>}
			game_type='likedislike'
		>
			{(missing_anything === false) ? (
				<LikeDislikeCanvas
					{...default_props}
					default_player_index={(preview_index !== false) ? preview_index : 0}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Upload at least 2 options"
					img_recommendations={{
						w:400,
						h:500,
					}}
				/>
			)}
		</SimpleCanvasContainer>
	);
};

export default injectIntl(LikeDislikeClient);